<template>
  <VerticalContainer>
    <TeamsTable
      :selected-team-id="selectedTeamId"
      @onClickRow="onChangeRow"
    />
    <ErrorMessage :error-message="errorMessage" />
    <template #buttons>
      <Button
        text="Select Workspace"
        :on-click="select"
        :disabled="isSelectButtonDisabled"
      />
      <Button
        text="Cancel"
        :on-click="goBack"
      />
    </template>
  </VerticalContainer>
</template>
<script>
import Button from '../../components/atoms/button/button';
import TeamsTable from '../../components/organisms/teams/teams-table';
import VerticalContainer from '../../components/organisms/layout/vertical-container';
import ErrorMessage from '../../components/atoms/message/error-message';
import { routeNames } from '../../constants';

export default {
  name: 'SwitchWorkspace',
  components: {
    Button,
    ErrorMessage,
    TeamsTable,
    VerticalContainer,
  },
  data() {
    return {
      selectedTeamId: '',
    };
  },
  computed: {
    isSelectButtonDisabled() {
      return this.currentlySelectedTeamId === this.selectedTeamId;
    },
    currentlySelectedTeamId() {
      return this.$store.state.teams.selectedTeam.id;
    },
    errorMessage() {
      return this.$store.state.teams.errorMessage;
    },
  },
  mounted() {
    this.selectedTeamId = this.$store.state.teams.selectedTeam.id;
  },
  methods: {
    onChangeRow(id) {
      this.selectedTeamId = id;
    },
    goBack() {
      this.navigateWithTeam(this.$route.params.teamId);
    },
    teamWithId(teamId) {
      return this.$store.state.teams.teams.find(({ id }) => id === teamId);
    },
    select() {
      this.$root.trackEvent.switchedTeam(
        this.$store.state.teams.selectedTeam,
        this.teamWithId(this.selectedTeamId),
      );
      this.navigateWithTeam(this.selectedTeamId);
    },
    navigateWithTeam(teamId) {
      const { returnTo } = this.$route.query;
      this.$router
        .push({
          name: returnTo || routeNames.team.list,
          params: { teamId },
        })
        .catch(() => {});
    },
  },
};
</script>
